import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

const declarations = [
]

@NgModule({
    declarations: [
        ...declarations,
    ],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        ...declarations,
    ]
})
export class DashboardModule {
}
